'use strict';

var angular = require('angular');
var modules = [];
module.exports = angular.module('AVRO.PricingSummary.SummaryDashboardLegendFilterModule', modules).factory('SummaryDashboardLegendFilterService', require('./services/SummaryDashboardLegendFilterService'));